import { EStarRating } from '../../../../packages/JsonQuery';
import { useCallback } from 'react';
import { useFilterChangeCallback } from 'shared/hooks';
import { FILTER_KEY } from '../constants';

export const useStartRatingChangeHandler = () => {
  const onChange = useFilterChangeCallback(FILTER_KEY);

  return useCallback(
    (starRating: EStarRating[] | null) => {
      onChange({ action: 'setStarRating', arguments: [starRating] });
    },
    [onChange],
  );
};
